var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1411,
    height: 1880,
    viewBox: "0 0 1411 1880",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.413 0C1001.37 0 1243.5 242.115 1243.5 538.076V919.954C1243.5 957.594 1239.56 994.357 1232.12 1029.88H1025.08C1037.03 995.371 1043.54 958.386 1043.54 919.954V538.076C1043.54 352.089 891.383 199.944 705.404 199.944C519.417 199.944 367.273 352.089 367.273 538.076V919.954C367.273 958.378 373.779 995.371 385.735 1029.88H178.705C171.262 994.357 167.328 957.594 167.328 919.954V538.076C167.328 242.115 409.46 0 705.413 0Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.437 735.491H1261.41C1343.59 735.491 1410.84 802.741 1410.84 884.928V1730.27C1410.84 1812.45 1343.59 1879.7 1261.41 1879.7H149.437C67.2499 1879.7 0 1812.46 0 1730.27V884.928C0 802.741 67.2414 735.491 149.437 735.491ZM796.559 1298.39V1488.41C796.559 1538.53 755.546 1579.53 705.43 1579.53H705.422C655.297 1579.53 614.302 1538.52 614.302 1488.41V1298.41C580.17 1271.46 558.259 1229.71 558.259 1182.86C558.259 1101.59 624.155 1035.69 705.422 1035.69C786.697 1035.69 852.593 1101.59 852.593 1182.86C852.593 1229.71 830.673 1271.44 796.567 1298.4L796.559 1298.39Z",
    fill: "#FFA042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.559 1298.39C830.665 1271.44 852.585 1229.7 852.585 1182.85C852.585 1101.58 786.689 1035.69 705.413 1035.69C624.146 1035.69 558.25 1101.58 558.25 1182.85C558.25 1229.7 580.161 1271.45 614.293 1298.4V1488.4C614.293 1538.52 655.297 1579.52 705.413 1579.52H705.422C755.538 1579.52 796.55 1538.51 796.55 1488.4V1298.38L796.559 1298.39Z",
    fill: "#472809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.95436582c02b51f7ce9cd77cbd0d02dd.svg";
export { ForwardRef as ReactComponent };